/*
 * Public API Surface of ngx-ellipsis
 */

export * from './lib/directives/ellipsis.directive';
export * from './lib/ellipsis.module';
